<template>
  <sticky-header-layout>

    <!-- Header -->
    <template #header>
      <div class="action-container justify-content-end">
        <span>
          <el-button
            :disabled="isSaving"
            class="cancel-button"
            size="mini"
            type="warning"
            icon="el-icon-close"
            @click="handleCancel"
          >{{ $t('button.cancel') }}</el-button>
        </span>
      </div>
    </template>
    <!-- Header -->

    <div>
      <el-upload
        v-loading="isUploading"
        ref="uploader"
        :limit="1"
        :disabled="isUploading"
        :http-request="handleUpload"
        :before-upload="handleBeforeUpload"
        :on-exceed="handleUploaderlimitExceed"
        :on-error="uploadfailed"
        :on-success="uploadSuccessful"
        :show-file-list="false"
        drag
        accept=".csv"
        action="noneed"
      >
        <i class="el-icon-upload" />
        <div
          class="el-upload__text"
          v-html="$t('file.dropCsvFileHereOrClickUpload')"
        />
        <div
          slot="tip"
          class="el-upload__tip">{{ $t('file.explainUpload') }}<a
            href="https://cdn.goxip.com/goxip_res/goxip_trending-feed-batch-create-sample.csv"
            style="color:blue"
            download="Trending_Template.csv">{{ $t('button.downloadTemplate') }}</a>
        </div>
      </el-upload>
    </div>

    <el-table
      v-if="resultList.length > 0"
      :data="resultList"
      stripe
      class="pt-4"
      empty-text="Upload first"
    >
      <el-table-column
        prop="row"
        label="Row"
        width="180"
      />

      <el-table-column
        prop="success"
        label="Success"
        width="180"
      >
        <template #default="{ row }">
          <font-awesome-icon
            :icon="row.success ? 'check' : 'times'"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="reason"
        label="Reason"
      />
    </el-table>

  </sticky-header-layout>

</template>

<script>
import { uploadTrendingBatch } from '../../../api/trending-feeds'

export default {
  name: 'UploadTrendingBatch',
  data() {
    return {
      isUploading: false,
      isSaving: false,
      resultList: [],
    }
  },
  watch: {
    handleSaveSuccess() {
      this.isSaving = false
      this.isEdited = false
      this.goToTrendingFeeds()
    },
    handleSaveFail(error) {
      this.isSaving = false
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: this.$t('button.ok'),
      })
    },
  },
  methods: {
    async handleUpload(uploadAction) {
      this.resultList = []
      this.isUploading = true

      const payload = {
        file: uploadAction.file,
      }

      try {
        const { data } = await uploadTrendingBatch(payload)
        this.resultList = data
        uploadAction.onSuccess()
      } catch (error) {
        uploadAction.onError(error)
      }
    },

    uploadSuccessful() {
      this.$refs.uploader.clearFiles()
      this.isUploading = false
    },
    uploadfailed() {
      this.isUploading = false
      this.$alert(
        'Please try again later.',
        'Upload Failed', {
          type: 'error',
          confirmButtonText: 'OK',
        },
      )
    },
    handleBeforeUpload(file) {
      if (!file.name.includes('.csv')) {
        this.$alert(
          'Please double check you are uploading a CSV file',
          'Incorrect File Type', {
            type: 'error',
            confirmButtonText: 'OK',
          },
        )
        return false
      }
      // Let user a chance to make sure he or she is uploading the correct report.
      return this.$confirm(
        `Do you want to upload the Trending Batch file (${file.name}) now?`,
        'Confirm Upload', {
          confirmButtonText: this.$t('button.upload'),
          cancelButtonText: this.$t('button.cancel'),
          type: 'warning',
        },
      )
        .then(() => true)
        .catch(() => Promise.reject())
    },
    handleUploaderlimitExceed() {
      this.$alert(
        'Sorry, please upload one file at a time!',
        'Too Many Files', {
          type: 'error',
          confirmButtonText: 'OK',
        },
      )
    },
    goToListPage() {
      this.$router.push({ path: '/trending-feeds/list' })
    },
    handleCancel() {
      this.goToListPage()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/form.scss";

</style>
